import { useMutation, useQueryClient } from 'react-query'
import { useAtomValue } from 'jotai'
import { STRIDE_CURRENCY } from '@/config'
import { strideAccountAtom } from '@/atoms/Wallet'
import { notify } from '@/atoms/Notifications'
import { queryKeys } from '@/query-keys'
import { redis } from '../redis'

const useRebateClaimMutation = () => {
  const strideAccount = useAtomValue(strideAccountAtom)

  const client = useQueryClient()

  const handleMutation = async () => {
    if (!strideAccount) {
      return
    }

    return await redis.set(`status_${strideAccount.key.bech32Address}`, 'PENDING')
  }

  const handleSuccess = async () => {
    if (!strideAccount) {
      // Wallet has likely been disconnected if strideAccount is non-existent at this point.
      return
    }

    await client.invalidateQueries(queryKeys.airdropRebateProgramBase)

    notify.success(`You have claimed your ${STRIDE_CURRENCY.coinDenom} tokens from the rebate program successfully.`)
  }

  return useMutation(handleMutation, { onSuccess: handleSuccess })
}

export { useRebateClaimMutation }
